import { render, staticRenderFns } from "./MakeClassScheduleFeedPopup.vue?vue&type=template&id=3d866050&scoped=true&"
import script from "./MakeClassScheduleFeedPopup.vue?vue&type=script&lang=js&"
export * from "./MakeClassScheduleFeedPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d866050",
  null
  
)

export default component.exports